import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#0A0C10]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <img src="/favicon.png" alt="Christovibes" className="w-8 h-8 rounded-full ring-1 ring-white/10" />
            <div>
              <p className="text-sm font-semibold text-white" style={{ fontFamily: 'Clash Display, sans-serif' }}>Christovibes</p>
              <p className="text-xs text-[#64748B]">Contemporary African Christian music · 24/7</p>
            </div>
          </div>
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
            <Link to="/privacy" data-testid="footer-privacy" className="text-[#94A3B8] hover:text-[#D4AF37]">Privacy</Link>
            <Link to="/terms" data-testid="footer-terms" className="text-[#94A3B8] hover:text-[#D4AF37]">Terms</Link>
            <Link to="/cookies" data-testid="footer-cookies" className="text-[#94A3B8] hover:text-[#D4AF37]">Cookies</Link>
            <Link to="/takedown" data-testid="footer-takedown" className="text-[#94A3B8] hover:text-[#D4AF37]">Takedown</Link>
            <button
              type="button"
              data-testid="footer-cookie-prefs"
              onClick={() => window.dispatchEvent(new Event('christovibes:reopen-cookie-banner'))}
              className="text-[#94A3B8] hover:text-[#D4AF37] cursor-pointer"
            >
              Cookie preferences
            </button>
            <a href="mailto:hello@christovibes.com" className="text-[#94A3B8] hover:text-[#D4AF37]">Contact</a>
          </nav>
        </div>
        <div className="mt-6 pt-6 border-t border-white/5 text-xs text-[#64748B] flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <span>© {new Date().getFullYear()} Christovibes Radio. All rights reserved.</span>
          <span className="text-[#475569]">Broadcasting on West Africa Time (WAT)</span>
        </div>
      </div>
    </footer>
  );
}
